"use client";

import type { ConvexApiModule } from "@packages/confect/rpc";
import type { ClawyAgentsModule } from "@packages/database/convex/rpc/clawyAgents";
import { anyApi } from "convex/server";
import { createRpcModuleClientContext } from "./client-context";

// The module type parameter carries all client typing; the runtime argument
// only supplies function paths. anyApi avoids instantiating the generated
// api object's type, which forces TypeScript to type every Convex module at
// once and trips TS2589. The module path is pinned by the database package's
// fnRefPaths.test.ts.
const moduleRef = (
	anyApi as unknown as { rpc: { clawyAgents: ConvexApiModule } }
).rpc.clawyAgents;

export const {
	RpcClientProvider: ClawyAgentsProvider,
	useRpcClient: useClawyAgents,
} = createRpcModuleClientContext<ClawyAgentsModule>(moduleRef);
